export const FILTER_BREEDS = 'FILTER_BREEDS';
export const SELECTED_BREEDS = "SELECTED_BREEDS";
export const LOADING = "LOADING";
export const ERROR = "ERROR";